import InvoiceView from "layouts/invoices/InvoiceView";

function CreditNoteView() {
  return <InvoiceView invoiceType="client" documentType="credit_note" />;
}

export default CreditNoteView;
